export default {
  path: 'subscriptions',
  name: 'product/subscriptions',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "product-show-subscriptions" */ './SubscriptionsTab')
}
